import * as z from "zod";
import { DownloadDtoSchema } from "../dto";

export const getDownload = {
  name: "getDownload" as const,
  input: z.object({ downloadId: z.string() }),
  output: z.object({
    download: DownloadDtoSchema,
    // Short-lived presigned URL, present only when the file is ready.
    downloadUrl: z.string().nullish(),
  }),
};
